import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Status } from '../services/status'
@Component({
  selector: 'app-confirmbox',
  templateUrl: './confirmbox.component.html',
  styleUrls: ['./confirmbox.component.scss']
})
export class ConfirmboxComponent implements OnInit {

  message!: string;
  status!: number;
  id!: number;  
  @Output() sendResponse: EventEmitter<any> = new EventEmitter();

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit() {
  }
  SendResponse() {
    let response = new Status(this.id, this.status)
    this.bsModalRef.hide();
    this.sendResponse.emit(response);
  }
}
